var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.4737C15.1765 11.4737 17.3462 9.35293 17.3462 6.73684C17.3462 4.12076 15.1765 2 12.5 2C9.82354 2 7.65385 4.12076 7.65385 6.73684C7.65385 9.35293 9.82354 11.4737 12.5 11.4737Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1154 12.5263H10.8846C9.45705 12.528 8.08845 13.083 7.07901 14.0697C6.06957 15.0564 5.50171 16.3941 5.5 17.7895V20.9474C5.5 21.2265 5.61346 21.4943 5.81542 21.6917C6.01739 21.8891 6.29131 22 6.57692 22H18.4231C18.7087 22 18.9826 21.8891 19.1846 21.6917C19.3865 21.4943 19.5 21.2265 19.5 20.9474V17.7895C19.4983 16.3941 18.9304 15.0564 17.921 14.0697C16.9116 13.083 15.5429 12.528 14.1154 12.5263Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.9ac6551ff874155c64c8fb749c323bc9.svg";
export { ForwardRef as ReactComponent };